import {BillRestResource} from "@/api/billing/billing-rest-resource";
import {BILLING_SERVER} from "@/api";
const BusinessOpportunitiesApi = new BillRestResource({server: BILLING_SERVER, resource: 'business-opportunities'});
export default BusinessOpportunitiesApi;